class MobileFilters {
  constructor() {
    this.sortPopup = document.getElementById('mobile-sort-popup');
    this.filterTrigger = document.querySelector('[data-filter-trigger]');
    this.sortTrigger = document.querySelector('[data-sort-trigger]');
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.preventFormSubmissions();
  }

  preventFormSubmissions() {
    // Only prevent form submissions for sort forms, not filter forms
    document.addEventListener('submit', (e) => {
      const form = e.target;
      const sortSelect = form.querySelector('select[name="sort_by"]');
      
      // Only prevent if it's a sort form, not a filter form
      if (sortSelect && form.closest('facet-filters-form') && !form.closest('.mobile-facets')) {
        e.preventDefault();
        console.log('Prevented form submission for sort form');
        return false;
      }
    });

    // Only intercept sort events, not filter events
    document.addEventListener('input', (e) => {
      if (e.target.name === 'sort_by' && e.target.closest('facet-filters-form') && !e.target.closest('.mobile-facets')) {
        console.log('Intercepted sort input event');
        e.stopPropagation();
        e.preventDefault();
        
        // Apply our custom sorting instead
        this.applySorting(e.target.value);
        return false;
      }
    });

    document.addEventListener('change', (e) => {
      if (e.target.name === 'sort_by' && e.target.closest('facet-filters-form') && !e.target.closest('.mobile-facets')) {
        console.log('Intercepted sort change event');
        e.stopPropagation();
        e.preventDefault();
        
        // Apply our custom sorting instead
        this.applySorting(e.target.value);
        return false;
      }
    });
  }

  bindEvents() {
    // Filter button - open default Shopify mobile filter
    if (this.filterTrigger) {
      this.filterTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openDefaultFilter();
      });
    }

    // Sort popup events
    if (this.sortTrigger) {
      this.sortTrigger.addEventListener('click', () => this.openSortPopup());
    }

    if (this.sortPopup) {
      // Close sort popup events
      const closeButtons = this.sortPopup.querySelectorAll('[data-sort-close]');
      closeButtons.forEach(button => {
        button.addEventListener('click', () => this.closeSortPopup());
      });

      // Sort option selection
      const sortOptions = this.sortPopup.querySelectorAll('.mobile-sort-popup__option');
      sortOptions.forEach(option => {
        option.addEventListener('click', () => this.selectSortOption(option));
      });
    }

    // Close modals when clicking outside
    document.addEventListener('click', (e) => {
      if (e.target.classList.contains('mobile-sort-popup__overlay')) {
        this.closeSortPopup();
      }
    });

    // Close modals with escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeSortPopup();
      }
    });
  }

  openDefaultFilter() {
    console.log('Opening default filter');
    
    // Find the default Shopify mobile filter button
    const mobileFilterButton = document.querySelector('.mobile-facets__open');
    if (mobileFilterButton) {
      console.log('Found mobile filter button, clicking it');
      
      // Check if the mobile facets wrapper is already open
      const mobileFacetsWrapper = document.querySelector('.mobile-facets__wrapper');
      const details = mobileFacetsWrapper ? mobileFacetsWrapper.querySelector('details') : null;
      
      if (details && details.open) {
        console.log('Mobile filter is already open');
        return;
      }
      
      // Click the button to open the filter
      mobileFilterButton.click();
      
      // Monitor if it closes immediately and reopen if needed
      setTimeout(() => {
        if (details && !details.open) {
          console.log('Filter closed immediately, reopening...');
          mobileFilterButton.click();
        }
      }, 200);
      
    } else {
      console.log('Mobile filter button not found, trying alternative');
      
      // Fallback: try to find the mobile facets wrapper and trigger it
      const mobileFacetsWrapper = document.querySelector('.mobile-facets__wrapper');
      if (mobileFacetsWrapper) {
        const details = mobileFacetsWrapper.querySelector('details');
        if (details) {
          console.log('Found mobile facets details, opening it');
          details.open = true;
          
          // Trigger any associated events
          const summary = details.querySelector('summary');
          if (summary) {
            summary.click();
          }
        }
      }
    }
  }

  openSortPopup() {
    if (this.sortPopup) {
      this.sortPopup.style.display = 'flex';
      // Trigger animation after display is set
      setTimeout(() => {
        this.sortPopup.classList.add('active');
      }, 10);
      document.body.style.overflow = 'hidden';
    }
  }

  closeSortPopup() {
    if (this.sortPopup) {
      this.sortPopup.classList.remove('active');
      setTimeout(() => {
        this.sortPopup.style.display = 'none';
        document.body.style.overflow = '';
      }, 300);
    }
  }


  selectSortOption(option) {
    const sortValue = option.getAttribute('data-sort-value');
    if (!sortValue) return;

    // Remove active class from all options
    const allOptions = this.sortPopup.querySelectorAll('.mobile-sort-popup__option');
    allOptions.forEach(opt => opt.classList.remove('active'));

    // Add active class to selected option
    option.classList.add('active');

    // Apply sorting immediately
    this.applySorting(sortValue);
    
    // Close popup after a short delay
    setTimeout(() => {
      this.closeSortPopup();
    }, 200);
  }

  applySorting(sortValue) {
    console.log('Applying sort:', sortValue);
    
    // Try to use the existing FacetFiltersForm system first
    const facetForm = document.querySelector('facet-filters-form');
    if (facetForm && typeof facetForm.onSubmitHandler === 'function') {
      // Find the sort select in the main form
      const sortSelect = facetForm.querySelector('select[name="sort_by"]');
      if (sortSelect) {
        console.log('Found sort select, updating value');
        sortSelect.value = sortValue;
        
        // Create a proper event object
        const mockEvent = {
          target: sortSelect,
          srcElement: sortSelect,
          preventDefault: () => {},
          currentTarget: sortSelect,
          type: 'change',
          bubbles: true
        };
        
        // Try to trigger the existing form submission
        try {
          facetForm.onSubmitHandler(mockEvent);
          console.log('Form submission triggered successfully');
          return;
        } catch (error) {
          console.error('Form submission failed:', error);
        }
      }
    }
    
    // Fallback: Try to find and trigger any sort form
    const sortForms = document.querySelectorAll('form');
    for (let form of sortForms) {
      const sortSelect = form.querySelector('select[name="sort_by"]');
      if (sortSelect) {
        console.log('Found sort select in form:', form.id);
        sortSelect.value = sortValue;
        
        // Try to trigger the form's input event
        const inputEvent = new Event('input', { bubbles: true });
        sortSelect.dispatchEvent(inputEvent);
        
        // Also try change event
        const changeEvent = new Event('change', { bubbles: true });
        sortSelect.dispatchEvent(changeEvent);
        
        return;
      }
    }
    
    // Last resort: Use AJAX approach
    console.log('Using AJAX fallback');
    this.applySortingAjax(sortValue);
  }

  applySortingAjax(sortValue) {
    // Show loading state
    this.showLoadingState();
    
    // Get current URL parameters
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('sort_by', sortValue);
    
    // Get the section ID from the product grid (works for both collection and search)
    const productGrid = document.getElementById('product-grid');
    const sectionId = productGrid ? productGrid.dataset.id : null;
    
    console.log('Section ID:', sectionId);
    console.log('Current URL:', currentUrl.toString());
    
    if (sectionId) {
      // Build the AJAX URL
      const ajaxUrl = `${window.location.pathname}?section_id=${sectionId}&${currentUrl.searchParams.toString()}`;
      console.log('AJAX URL:', ajaxUrl);
      
      // Fetch the updated content
      fetch(ajaxUrl)
        .then(response => {
          console.log('Fetch response:', response.status);
          return response.text();
        })
        .then(html => {
          console.log('HTML received, length:', html.length);
          
          // Parse the response
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          
          // Update the product grid container
          const newProductGridContainer = doc.getElementById('ProductGridContainer');
          const currentProductGridContainer = document.getElementById('ProductGridContainer');
          
          if (newProductGridContainer && currentProductGridContainer) {
            console.log('Updating product grid container');
            currentProductGridContainer.innerHTML = newProductGridContainer.innerHTML;
          }
          
          // Update the product count (works for both collection and search)
          const newProductCount = doc.getElementById('ProductCount');
          const currentProductCount = document.getElementById('ProductCount');
          const currentProductCountDesktop = doc.getElementById('ProductCountDesktop');
          const currentProductCountDesktopElement = document.getElementById('ProductCountDesktop');
          
          if (newProductCount && currentProductCount) {
            currentProductCount.innerHTML = newProductCount.innerHTML;
          }
          if (currentProductCountDesktopElement && currentProductCountDesktop) {
            currentProductCountDesktopElement.innerHTML = currentProductCountDesktop.innerHTML;
          }
          
          // Update active facets for both collection and search
          const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];
          activeFacetElementSelectors.forEach((selector) => {
            const newActiveFacets = doc.querySelector(selector);
            const currentActiveFacets = document.querySelector(selector);
            if (newActiveFacets && currentActiveFacets) {
              currentActiveFacets.innerHTML = newActiveFacets.innerHTML;
            }
          });
          
          // Update URL without reload
          window.history.pushState({}, '', currentUrl.toString());
          
          // Hide loading state
          this.hideLoadingState();
          
          console.log('Sort applied successfully via AJAX');
        })
        .catch(error => {
          console.error('AJAX Error:', error);
          this.hideLoadingState();
          // Fallback to page reload
          console.log('Falling back to page reload');
          window.location.href = currentUrl.toString();
        });
    } else {
      console.log('No section ID found, using page reload');
      // Fallback to page reload if section ID not found
      window.location.href = currentUrl.toString();
    }
  }

  showLoadingState() {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collection = productGridContainer.querySelector('.collection');
      if (collection) {
        collection.classList.add('loading');
      }
    }
  }

  hideLoadingState() {
    const productGridContainer = document.getElementById('ProductGridContainer');
    if (productGridContainer) {
      const collection = productGridContainer.querySelector('.collection');
      if (collection) {
        collection.classList.remove('loading');
      }
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new MobileFilters();
});

// Also initialize if DOM is already loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new MobileFilters();
  });
} else {
  new MobileFilters();
}
